import React, { useEffect } from 'react';
import './FirmwareDesignPage.css';

const FirmwareDesignPage = () => {
    useEffect(() => {
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => observer.observe(element));

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Embedded Systems Development",
            description: "Crafting firmware for microcontrollers and embedded systems with optimized performance."
        },
        {
            title: "Real-Time Operating Systems (RTOS)",
            description: "Implementing RTOS for time-critical IoT applications."
        },
        {
            title: "Wireless Connectivity",
            description: "Supporting protocols like Wi-Fi, Bluetooth, and Zigbee for seamless device communication."
        },
        {
            title: "Firmware Security",
            description: "Integrating encryption and secure boot mechanisms to protect IoT devices."
        },
        {
            title: "Over-the-Air (OTA) Updates",
            description: "Enabling remote firmware updates for enhanced device longevity and flexibility."
        },
        {
            title: "Microcontroller & Microprocessor Programming",
            description: "Expertise in programming microcontrollers, microprocessors, and SOC/SOM for optimized performance in IoT devices."
        },
        {
            title: "BSP, Drivers, and Firmware",
            description: "Developing Board Support Packages (BSP), custom drivers, and bare-metal firmware for seamless hardware integration."
        },
        {
            title: "Bootloaders & Algorithms",
            description: "Crafting robust bootloaders and efficient algorithms to ensure reliable device startup and operation."
        },
        {
            title: "Board Bring-up & Diagnostics",
            description: "Comprehensive board bring-up, diagnostic tools, and production test software for quality assurance."
        },
        {
            title: "Network, Storage, and Wireless",
            description: "Implementing network, storage, and wireless solutions, including RF, BLE, and specific drivers for connectivity."
        },
        {
            title: "I/O Peripherals Integration",
            description: "Integrating sensors, cameras, motors, gyroscopes, and other peripherals for versatile IoT applications."
        },
        {
            title: "Embedded OS Development",
            description: "Supporting Windows, Linux, FreeRTOS, and Open CPU for robust embedded systems."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.5s' }}>
                Firmware Design and Development
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.5s' }}>
                Our firmware design services deliver robust, scalable, and efficient solutions tailored for IoT devices, ensuring seamless integration with hardware and software ecosystems.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.5s' }}>
                Key notes
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.2 + index * 0.2}s` }}  
                    >
                        <strong className='topic-title'>{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))} 
            </ul>
        </div>
    );
};

export default FirmwareDesignPage;